
(() => {
  "use strict";
  document.documentElement.classList.add("js");
  const CONFIG = {
    STREAK_START: "2001-01-01",
    RACE_DATE:    "2027-06-12T07:00:00",
    PHASES: [[24,"Base"],[12,"Build"],[3,"Peak"],[1,"Taper"],[0,"Race week"]],  // [weeks-out threshold, label] — edit to match your plan
    SEASON_MILES: 0,            // set your real season total here, OR leave 0 and wire STRAVA_ENDPOINT below
    STRAVA_ENDPOINT: ""         // paste your Strava Worker /strava URL to pull miles live. While SEASON_MILES is 0 and this is empty, the tile shows "—" (never a fake number).
  };
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) document.querySelectorAll("svg").forEach(s => { try { s.pauseAnimations && s.pauseAnimations(); } catch (e) {} });
  const $ = s => document.querySelector(s);
  const PHI = 1.6180339887, TAU = Math.PI * 2;
  const set = (id, html) => { const el = document.getElementById(id); if (el) el.innerHTML = html; };

  const fmt = n => n.toLocaleString();
  function tick(){
    const now = Date.now();
    const days = Math.floor((now - new Date(CONFIG.STREAK_START)) / 86400000);
    const yrs = (days / 365.25).toFixed(1);
    set("lStreak", fmt(days));
    set("hStreak", fmt(days) + " days");
    const sinceEl = document.getElementById("lStreakSince");
    if (sinceEl) sinceEl.textContent = "Running every day · " + yrs + " years";
    const ms = new Date(CONFIG.RACE_DATE) - now;
    if (ms > 0){
      const d = Math.floor(ms/86400000), h = Math.floor(ms/3600000)%24, m = Math.floor(ms/60000)%60, s = Math.floor(ms/1000)%60;
      set("lCountD", fmt(d));
      set("lCountHMS", String(h).padStart(2,"0")+"h "+String(m).padStart(2,"0")+"m "+String(s).padStart(2,"0")+"s");
      set("hCount", d+'<small> d</small> '+String(h).padStart(2,"0")+'<small> h</small> '+String(m).padStart(2,"0")+'<small> m</small>');
      const wk = Math.ceil(ms / 604800000);
      let ph = "";
      for (const p of CONFIG.PHASES){ if (wk > p[0]){ ph = p[1]; break; } }
      const pTxt = ph ? (wk > 1 ? ph + " · " + wk + " wks out" : ph) : "";
      const pEl = document.getElementById("lPhase");
      if (pEl && pTxt && pEl.textContent !== pTxt){ pEl.hidden = false; pEl.textContent = pTxt; }
      const hp = document.getElementById("hPhase");
      if (hp && ph && hp.textContent !== ph) hp.textContent = ph;
    } else {
      set("lCountD","0"); set("lCountHMS","RACE DAY"); set("hCount","RACE DAY");
      const pEl = document.getElementById("lPhase"); if (pEl) pEl.hidden = true;
    }
  }
  tick(); setInterval(tick, 1000);
  // Season miles: set ONCE here (not inside the per-second tick, so a live Strava value is never overwritten).
  // Honest fallback — shows "—" rather than a fake "0" until a real number or a Strava feed exists.
  (function initShare(){
    const b = document.getElementById("footShare"), t = document.getElementById("footShareTxt");
    if (!b || !t) return;
    const URL_C = "https://carterluense.ai/";
    const data = { title: "Carter Luense — Triathlete & Founder", text: "Swim · Bike · Run — the road to IRONMAN 70.3 Boulder.", url: URL_C };
    b.addEventListener("click", async () => {
      try {
        if (navigator.share){ await navigator.share(data); return; }
        await navigator.clipboard.writeText(URL_C);
        t.textContent = "Copied";
        setTimeout(() => { t.textContent = "Share"; }, 1600);
      } catch (e) { /* user cancelled or clipboard unavailable — stay quiet */ }
    });
  })();
  console.info("%c\u16da \u16b1 \u16d6%c  carterluense.ai \u00b7 one file \u00b7 honest numbers \u00b7 every proportion by \u03c6",
    "color:#e7c869;font-size:14px;letter-spacing:.2em", "color:#8a8a8a;font-family:monospace");
  (function syncStreakCopy(){
    // Static "N+ years" copy derives from CONFIG.STREAK_START so it can never drift from the live counter.
    const days = Math.floor((Date.now() - new Date(CONFIG.STREAK_START)) / 86400000);
    const label = Math.floor(days / 365.25) + "+";
    document.querySelectorAll(".js-syrs").forEach(el => { el.textContent = label; });
  })();
  (function initMiles(){
    const el = document.getElementById("lMiles");
    if (!el) return;
    if (CONFIG.SEASON_MILES > 0) el.textContent = CONFIG.SEASON_MILES.toLocaleString();
    else el.textContent = "—";
  })();
  async function loadStrava(){
    if(!CONFIG.STRAVA_ENDPOINT) return;
    try{
      const r = await fetch(CONFIG.STRAVA_ENDPOINT, { cache:"no-store" });
      if(!r.ok) return;
      const d = await r.json();
      if(typeof d.season_miles === "number"){ const el=document.getElementById("lMiles"); if(el) el.textContent=d.season_miles.toLocaleString(); }
      if(d.ytd){ const sub=document.getElementById("lMilesSub"); if(sub) sub.textContent="Run "+Math.round(d.ytd.run)+" · Ride "+Math.round(d.ytd.ride)+" · Swim "+Math.round(d.ytd.swim); }
    }catch(e){}
  }
  loadStrava(); setInterval(loadStrava, 15*60*1000);
  /* ══ THE LOG · ADD POSTS HERE — newest first. date is a display string; keep it short. ══ */
  const POSTS = [
    { date: "Jul 09 · 2026", tag: "The build", title: "The log opens",
      ex: "A place for honest check-ins on the road to Boulder.",
      body: "The site got a full rebuild this summer — grove, gold, storm and all — and this section is where the season gets written down as it happens: training blocks, setbacks, gear that earns its place, and the countdown doing its work. No highlight reel. The whole thing." },
    { date: "Jun 2026", tag: "The stable", title: "Six bikes deep",
      ex: "The fleet is complete: five Treks and a Creo.",
      body: "Speed Concept for race day, Madone for the road, Checkmate and Checkpoint for the dirt, the Creo for big easy days, and the 2015 FX that never left. Eighteen years off the bike — now every surface is covered. Making up for lost time." },
    { date: "Feb 2026", tag: "The body", title: "Under the knife, again",
      ex: "Torn hip labrum, repaired. The rebuild starts same-day.",
      body: "Second surgery in two years, after the shoulder in summer 2024. The pattern by now is familiar: go under, come back on purpose, don't waste the winter. Months later — all in." }
  ];
  (function(){
    const g = document.getElementById("logGrid");
    if (!g) return;
    g.innerHTML = POSTS.map(p =>
      '<article class="log__card"><span class="log__date">' + p.date + '</span><span class="log__tag">' + p.tag + '</span>' +
      '<h3 class="log__title">' + p.title + '</h3><p class="log__ex">' + p.ex + '</p>' +
      '<div class="log__body">' + p.body + '</div>' +
      '<div class="log__more"><span class="o">Read +</span><span class="c">Close −</span></div></article>'
    ).join("");
    g.addEventListener("click", e => { const card = e.target.closest(".log__card"); if (card) card.classList.toggle("open"); });
  })();
  const yrEl = document.getElementById("yr"); if (yrEl) yrEl.textContent = new Date().getFullYear();
  const toTop = document.getElementById("toTop");
  if (toTop){
    const onScr = () => toTop.classList.toggle("show", scrollY > 640);
    addEventListener("scroll", onScr, { passive:true }); onScr();
    toTop.addEventListener("click", () => scrollTo({ top:0, behavior: reduce ? "auto" : "smooth" }));
  }

  try {
    const nav = $("#nav"), hero = $("#top");
    new IntersectionObserver(([e]) => nav.classList.toggle("stuck", !e.isIntersecting), { rootMargin: "-72px 0px 0px 0px" }).observe(hero);
  } catch (e) {}
  try {
    const burger = $("#burger"), mobile = $("#mobile");
    const setBurger = open => { burger.classList.toggle("open", open); mobile.classList.toggle("open", open); burger.setAttribute("aria-expanded", open ? "true" : "false"); document.body.classList.toggle("menu-open", open); };
    burger.addEventListener("click", () => setBurger(!burger.classList.contains("open")));
    document.addEventListener("keydown", e => { if (e.key === "Escape" && mobile.classList.contains("open")) setBurger(false); });
    mobile.querySelectorAll("a").forEach(a => a.addEventListener("click", () => setBurger(false)));
  } catch (e) {}
  try {
    const rio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting){ e.target.classList.add("in"); rio.unobserve(e.target); } }), { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll(".rv").forEach(el => rio.observe(el));
  } catch (e) { document.querySelectorAll(".rv").forEach(el => el.classList.add("in")); }
  setTimeout(() => {
    // Reveal sweep: anything the observer missed but is on screen gets shown. Invisible when the observer works.
    document.querySelectorAll(".rv:not(.in)").forEach(el => { const r = el.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) el.classList.add("in"); });
  }, 1500);

  const ptr = { nx:0, ny:0 };
  addEventListener("pointermove", e => { ptr.nx = e.clientX/innerWidth - 0.5; ptr.ny = e.clientY/innerHeight - 0.5; }, { passive:true });
  let _m=null; const mono = () => _m || (_m = getComputedStyle(document.documentElement).getPropertyValue("--mono").trim() || "ui-monospace,Menlo,monospace");
  const onScreen = el => { const r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight; };

  /* ── PORTAL 1 · LUND STUDIO — φ life-spiral ── */
  (() => {
    const cv = document.getElementById("lundC"); if (!cv) return;
    const ctx = cv.getContext("2d", { alpha:false });
    const sec = cv.parentElement;
    const V = { w:0,h:0,cx:0,cy:0,R:1,dpr:1,narrow:false };
    const AGE_FIN = 35, POW = 1/PHI;
    const uOf = a => Math.pow(Math.max(0,a)/AGE_FIN, POW);
    const TURNS = 1.85, TH0 = -Math.PI*0.62, KEXP = 3.05;
    const rNorm = u => (Math.pow(PHI,KEXP*u)-1)/(Math.pow(PHI,KEXP)-1);
    const ang = u => TH0 + u*TURNS*TAU;
    const smooth = (a,b,x) => { x=Math.min(1,Math.max(0,(x-a)/(b-a))); return x*x*(3-2*x); };
    const LANES = [ {age:3,off:0,col:[104,194,224],name:"SWIM"}, {age:6,off:13,col:[108,228,158],name:"RUN"}, {age:34,off:26,col:[236,118,46],name:"BIKE"} ];
    const DUST = []; for (let i=0;i<460;i++) DUST.push({ a:i*137.50776*Math.PI/180, r:Math.sqrt(i+1), ph:(i*0.7)%TAU, sp:0.4+((i*37)%100)/100*0.7 });
    function resize(){
      V.w = sec.clientWidth; V.h = sec.clientHeight; V.dpr = Math.min(V.w < 860 ? 1.5 : 2, devicePixelRatio||1);
      cv.width = Math.round(V.w*V.dpr); cv.height = Math.round(V.h*V.dpr); cv.style.width=V.w+"px"; cv.style.height=V.h+"px"; ctx.setTransform(V.dpr,0,0,V.dpr,0,0);
      V.narrow = V.w < 860; V.cx = V.narrow ? V.w*0.5 : V.w*0.70; V.cy = V.narrow ? V.h*0.32 : V.h*0.5; V.R = Math.min(V.w,V.h) * (V.narrow ? 0.40 : 0.46);
    }
    let mx=0,my=0, t0=performance.now();
    function frame(now){
      if (!onScreen(sec)){ requestAnimationFrame(frame); return; }
      const tt=(now-t0)/1000; mx += (ptr.nx-mx)*0.05; my += (ptr.ny-my)*0.05;
      const cx=V.cx+mx*26, cy=V.cy+my*18;
      const P=(u,ro)=>{ const a=ang(u),R=rNorm(u)*V.R+(ro||0); return {x:cx+Math.cos(a)*R,y:cy+Math.sin(a)*R}; };
      const g=ctx.createRadialGradient(cx,cy,0,cx,cy,V.R*2.2); g.addColorStop(0,"#17744a"); g.addColorStop(.42,"#0f4d31"); g.addColorStop(1,"#072b1a"); ctx.fillStyle=g; ctx.fillRect(0,0,V.w,V.h);
      ctx.save(); [3,6,12,22,34].forEach(a=>{ const R=rNorm(uOf(a))*V.R; ctx.beginPath(); ctx.arc(cx,cy,R,0,TAU); ctx.strokeStyle="rgba(212,194,138,0.07)"; ctx.lineWidth=1; ctx.stroke(); }); ctx.restore();
      const ds=V.R/Math.sqrt(DUST.length)*1.5; ctx.save(); const dustN = V.narrow ? 230 : DUST.length;
      for(let di=0; di<dustN; di++){ const p=DUST[di]; const R=p.r*ds,x=cx+Math.cos(p.a)*R,y=cy+Math.sin(p.a)*R,tw=0.4+0.6*Math.sin(tt*p.sp+p.ph); ctx.beginPath(); ctx.arc(x,y,1.0,0,TAU); ctx.fillStyle="rgba(204,180,120,"+(0.2*tw)+")"; ctx.fill(); } ctx.restore();
      ctx.save(); ctx.beginPath(); for(let u=0;u<=1.0001;u+=0.003){ const q=P(u,0); u===0?ctx.moveTo(q.x,q.y):ctx.lineTo(q.x,q.y); } ctx.strokeStyle="rgba(220,186,104,0.32)"; ctx.lineWidth=1.6; ctx.stroke(); ctx.restore();
      ctx.save(); ctx.lineCap="round"; ctx.lineJoin="round"; const flow=(tt*0.16)%1;
      for(const L of LANES){ const u0=uOf(L.age),r=L.col[0],gn=L.col[1],b=L.col[2], offAt=u=>L.off*(1-smooth(0.74,1,u));
        ctx.beginPath(); for(let u=u0;u<=1.0001;u+=0.0025){ const q=P(u,offAt(u)); u===u0?ctx.moveTo(q.x,q.y):ctx.lineTo(q.x,q.y); }
        ctx.shadowBlur=V.narrow?0:16; ctx.shadowColor="rgba("+r+","+gn+","+b+",.5)"; ctx.strokeStyle="rgba("+r+","+gn+","+b+",.18)"; ctx.lineWidth=6; ctx.stroke(); ctx.shadowBlur=0;
        ctx.beginPath(); for(let u=u0;u<=1.0001;u+=0.0025){ const q=P(u,offAt(u)); u===u0?ctx.moveTo(q.x,q.y):ctx.lineTo(q.x,q.y); } ctx.strokeStyle="rgba("+r+","+gn+","+b+",.92)"; ctx.lineWidth=2.3; ctx.stroke();
        const lu=u0+(1-u0)*((flow+L.age/40)%1),lp=P(lu,offAt(lu)); ctx.shadowBlur=V.narrow?0:18; ctx.shadowColor="rgb("+r+","+gn+","+b+")"; ctx.beginPath(); ctx.arc(lp.x,lp.y,3,0,TAU); ctx.fillStyle="rgba("+r+","+gn+","+b+",.95)"; ctx.fill(); ctx.shadowBlur=0;
        const sp=P(u0,L.off); ctx.beginPath(); ctx.arc(sp.x,sp.y,4,0,TAU); ctx.fillStyle="rgb("+r+","+gn+","+b+")"; ctx.fill(); ctx.beginPath(); ctx.arc(sp.x,sp.y,8,0,TAU); ctx.strokeStyle="rgba("+r+","+gn+","+b+",.4)"; ctx.lineWidth=1.1; ctx.stroke();
        if(!V.narrow){ ctx.font="600 14px "+mono(); ctx.textBaseline="middle"; const right=Math.cos(ang(u0))>=-0.2; ctx.textAlign=right?"left":"right"; ctx.fillStyle="rgb("+r+","+gn+","+b+")"; ctx.fillText(L.name+" · "+L.age, sp.x+(right?13:-13), sp.y); } }
      ctx.restore();
      const F=P(1,0),pulse=0.7+0.3*Math.sin(tt*1.6); ctx.save();
      const fg=ctx.createRadialGradient(F.x,F.y,0,F.x,F.y,30); fg.addColorStop(0,"rgba(231,194,92,"+(0.85*pulse)+")"); fg.addColorStop(.5,"rgba(231,194,92,.25)"); fg.addColorStop(1,"rgba(231,194,92,0)");
      ctx.fillStyle=fg; ctx.beginPath(); ctx.arc(F.x,F.y,30,0,TAU); ctx.fill(); ctx.fillStyle="#fff"; ctx.beginPath(); ctx.arc(F.x,F.y,4.5,0,TAU); ctx.fill();
      ctx.beginPath(); ctx.arc(F.x,F.y,13+3*Math.sin(tt*1.6),0,TAU); ctx.strokeStyle="rgba(231,194,92,.55)"; ctx.lineWidth=1.3; ctx.stroke();
      if(!V.narrow){ ctx.font="700 14px "+mono(); ctx.fillStyle="rgba(245,240,232,.92)"; ctx.textAlign="right"; ctx.textBaseline="bottom"; ctx.fillText("FINISH · 70.3 BOULDER", F.x-18, F.y-8); ctx.font="500 14px "+mono(); ctx.fillStyle="rgba(200,206,214,.9)"; ctx.textBaseline="top"; ctx.fillText("06 · 12 · 2027", F.x-18, F.y+8); }
      ctx.restore();
      ctx.save(); ctx.fillStyle="rgba(247,217,168,.8)"; ctx.beginPath(); ctx.arc(cx,cy,2.4,0,TAU); ctx.fill(); ctx.restore();
      if(!reduce) requestAnimationFrame(frame);
    }
    addEventListener("resize", resize, { passive:true }); resize();
    if(reduce) frame(performance.now()); else requestAnimationFrame(frame);
  })();

  /* ── PORTAL 2 · SIDEREP — the match network ── */
  (() => {
    const cv = document.getElementById("srC"); if (!cv) return;
    const ctx = cv.getContext("2d", { alpha:false });
    const sec = cv.parentElement;
    const V = { w:0,h:0,cx:0,cy:0,R:1,dpr:1,narrow:false };
    let nodes=[], edges=[], pulses=[];
    function build(){
      nodes=[]; edges=[];
      nodes.push({ a:0, rad:0, bob:0, bsp:0, center:true, ring:-1 });
      const rings=[ {n:7,rad:0.42}, {n:11,rad:0.74}, {n:13,rad:1.04} ];
      rings.forEach((ring,ri)=>{ for(let i=0;i<ring.n;i++){ const a=(i/ring.n)*TAU + ri*0.5 + Math.random()*0.3;
        nodes.push({ a, rad:ring.rad*(0.9+Math.random()*0.2), bob:Math.random()*TAU, bsp:0.4+Math.random()*0.6, center:false, ring:ri }); } });
      for(let i=1;i<nodes.length;i++){ if(nodes[i].ring===0) edges.push([0,i]); }
      for(let i=1;i<nodes.length;i++){ if(nodes[i].center) continue; let best=-1,bd=1e9;
        for(let j=1;j<nodes.length;j++){ if(j===i||nodes[j].ring>=nodes[i].ring) continue; const d=Math.abs(nodes[i].a-nodes[j].a); const dd=Math.min(d,TAU-d); if(dd<bd){ bd=dd; best=j; } }
        if(best>0) edges.push([i,best]); }
      pulses=[];
    }
    function pos(nd,cx,cy,tt){ if(nd.center) return {x:cx,y:cy}; const wob=Math.sin(tt*nd.bsp+nd.bob)*6; const R=nd.rad*V.R+wob; return { x:cx+Math.cos(nd.a)*R, y:cy+Math.sin(nd.a)*R }; }
    function resize(){
      V.w=sec.clientWidth; V.h=sec.clientHeight; V.dpr=Math.min(V.w<860?1.5:2,devicePixelRatio||1);
      cv.width=Math.round(V.w*V.dpr); cv.height=Math.round(V.h*V.dpr); cv.style.width=V.w+"px"; cv.style.height=V.h+"px"; ctx.setTransform(V.dpr,0,0,V.dpr,0,0);
      V.narrow=V.w<860; V.cx=V.narrow?V.w*0.5:V.w*0.32; V.cy=V.narrow?V.h*0.32:V.h*0.5; V.R=Math.min(V.w,V.h)*(V.narrow?0.34:0.42);
    }
    let mx=0,my=0,t0=performance.now(),lastSpawn=0;
    function frame(now){
      if(!onScreen(sec)){ requestAnimationFrame(frame); return; }
      const tt=(now-t0)/1000; mx+=(ptr.nx-mx)*0.05; my+=(ptr.ny-my)*0.05; const cx=V.cx+mx*24, cy=V.cy+my*16;
      ctx.fillStyle="#7a2a0a"; ctx.fillRect(0,0,V.w,V.h);
      const g=ctx.createRadialGradient(cx,cy,0,cx,cy,V.R*2); g.addColorStop(0,"rgba(241,120,60,0.62)"); g.addColorStop(.55,"rgba(196,74,26,0.30)"); g.addColorStop(1,"rgba(122,42,10,0)"); ctx.fillStyle=g; ctx.fillRect(0,0,V.w,V.h);
      ctx.save(); ctx.lineWidth=1;
      for(const e of edges){ const a=pos(nodes[e[0]],cx,cy,tt), b=pos(nodes[e[1]],cx,cy,tt); ctx.beginPath(); ctx.moveTo(a.x,a.y); ctx.lineTo(b.x,b.y); ctx.strokeStyle="rgba(93,127,140,0.12)"; ctx.stroke(); }
      ctx.restore();
      if(now-lastSpawn > 520 && pulses.length < 10){ lastSpawn=now; const e=edges[(Math.random()*edges.length)|0]; pulses.push({e, t:0}); }
      ctx.save(); pulses=pulses.filter(p=>p.t<1);
      for(const p of pulses){ p.t+=0.018; const a=pos(nodes[p.e[0]],cx,cy,tt), b=pos(nodes[p.e[1]],cx,cy,tt); const x=a.x+(b.x-a.x)*p.t, y=a.y+(b.y-a.y)*p.t;
        ctx.beginPath(); ctx.moveTo(a.x,a.y); ctx.lineTo(x,y); ctx.strokeStyle="rgba(205,216,222,0.55)"; ctx.lineWidth=1.4; ctx.stroke();
        ctx.shadowBlur=V.narrow?0:12; ctx.shadowColor="#cdd8de"; ctx.beginPath(); ctx.arc(x,y,2.2,0,TAU); ctx.fillStyle="#e8eef1"; ctx.fill(); ctx.shadowBlur=0; }
      ctx.restore();
      ctx.save();
      for(let k=0;k<nodes.length;k++){ const nd=nodes[k],q=pos(nd,cx,cy,tt);
        if(nd.center){ const pulse=0.7+0.3*Math.sin(tt*1.5);
          const fg=ctx.createRadialGradient(q.x,q.y,0,q.x,q.y,28); fg.addColorStop(0,"rgba(109,138,153,"+(0.8*pulse)+")"); fg.addColorStop(.5,"rgba(109,138,153,.25)"); fg.addColorStop(1,"rgba(109,138,153,0)");
          ctx.fillStyle=fg; ctx.beginPath(); ctx.arc(q.x,q.y,28,0,TAU); ctx.fill();
          ctx.fillStyle="#fff"; ctx.beginPath(); ctx.arc(q.x,q.y,5,0,TAU); ctx.fill();
          ctx.beginPath(); ctx.arc(q.x,q.y,12+2*Math.sin(tt*1.5),0,TAU); ctx.strokeStyle="rgba(109,138,153,.6)"; ctx.lineWidth=1.3; ctx.stroke();
          if(!V.narrow){ ctx.font="700 14px "+mono(); ctx.fillStyle="rgba(245,240,232,.92)"; ctx.textAlign="left"; ctx.textBaseline="middle"; ctx.fillText("YOU", q.x+18, q.y); }
        } else { const tw=0.55+0.45*Math.sin(tt*nd.bsp+nd.bob), sz=nd.ring===0?3:2.2; const col=nd.ring===0?"150,178,193":"90,120,138";
          ctx.beginPath(); ctx.arc(q.x,q.y,sz,0,TAU); ctx.fillStyle="rgba("+col+","+(0.5+0.4*tw)+")"; ctx.fill(); } }
      ctx.restore();
      if(!reduce) requestAnimationFrame(frame);
    }
    addEventListener("resize", resize, { passive:true }); resize(); build();
    if(reduce) frame(performance.now()); else requestAnimationFrame(frame);
  })();

  /* ── live band · deep space ── */
  (() => {
    const cv = document.getElementById("liveStars"); if(!cv) return;
    const ctx = cv.getContext("2d", { alpha:false });
    const sec = cv.parentElement;
    const V={w:0,h:0,dpr:1};
    const ACC=[[231,200,105],[240,234,216],[38,223,133],[212,85,29]]; // gold·white·green·ember
    let stars=[], neb=[], shoot=null, lastShoot=0;
    function build(){
      stars=[]; const n=Math.min(280, Math.floor(V.w*V.h/8200));
      for(let i=0;i<n;i++){ const d=Math.random();
        stars.push({ x:Math.random()*V.w, y:Math.random()*V.h, r:0.4+d*1.5, base:0.22+Math.random()*0.6,
          tw:Math.random()*TAU, tsp:0.3+Math.random()*1.3, dx:0.015+d*0.07,
          tint:Math.random()<0.20?ACC[(Math.random()*ACC.length)|0]:null, cross:d>0.88 }); }
      neb=[]; for(let i=0;i<4;i++) neb.push({ cx:(i+0.5)/4, cy:0.46+(Math.random()*0.28-0.14),
        r:0.46+Math.random()*0.3, col:ACC[i], ph:Math.random()*TAU, sp:0.04+Math.random()*0.05 });
    }
    function resize(){ V.dpr=Math.min(2,devicePixelRatio||1); V.w=sec.clientWidth; V.h=sec.clientHeight;
      cv.width=Math.round(V.w*V.dpr); cv.height=Math.round(V.h*V.dpr); cv.style.width=V.w+"px"; cv.style.height=V.h+"px";
      ctx.setTransform(V.dpr,0,0,V.dpr,0,0); build(); }
    let t0=performance.now();
    function frame(now){
      if(!onScreen(sec)){ requestAnimationFrame(frame); return; }
      const tt=(now-t0)/1000;
      const g=ctx.createRadialGradient(V.w*0.5,V.h*0.38,0,V.w*0.5,V.h*0.5,V.w*0.72);
      g.addColorStop(0,"#0c0a08"); g.addColorStop(1,"#070504"); ctx.fillStyle=g; ctx.fillRect(0,0,V.w,V.h);
      for(const nb of neb){ const x=nb.cx*V.w+Math.sin(tt*nb.sp+nb.ph)*30, y=nb.cy*V.h+Math.cos(tt*nb.sp*0.8+nb.ph)*16, R=nb.r*Math.min(V.w,V.h);
        const ng=ctx.createRadialGradient(x,y,0,x,y,R); const c=nb.col;
        ng.addColorStop(0,"rgba("+c[0]+","+c[1]+","+c[2]+",0.06)"); ng.addColorStop(1,"rgba("+c[0]+","+c[1]+","+c[2]+",0)");
        ctx.fillStyle=ng; ctx.fillRect(0,0,V.w,V.h); }
      const mx=ptr.nx*14;
      for(const s of stars){ s.x+=s.dx; if(s.x>V.w+2) s.x=-2;
        const px=s.x+mx*(s.r/1.8), a=s.base*(0.5+0.5*Math.sin(tt*s.tsp+s.tw));
        const col=s.tint?"rgba("+s.tint[0]+","+s.tint[1]+","+s.tint[2]+","+a+")":"rgba(245,243,234,"+a+")";
        ctx.beginPath(); ctx.arc(px,s.y,s.r,0,TAU); ctx.fillStyle=col; ctx.fill();
        if(s.cross){ ctx.strokeStyle="rgba(245,243,234,"+(a*0.5)+")"; ctx.lineWidth=0.6;
          ctx.beginPath(); ctx.moveTo(px-s.r*2.8,s.y); ctx.lineTo(px+s.r*2.8,s.y); ctx.moveTo(px,s.y-s.r*2.8); ctx.lineTo(px,s.y+s.r*2.8); ctx.stroke(); } }
      if(!shoot && now-lastShoot>4800 && Math.random()<0.018){ shoot={ x:Math.random()*V.w*0.55, y:Math.random()*V.h*0.4, vx:6+Math.random()*4, vy:1.8+Math.random()*1.4, life:0, max:64+Math.random()*30 }; lastShoot=now; }
      if(shoot){ shoot.life++; shoot.x+=shoot.vx; shoot.y+=shoot.vy; const fade=1-shoot.life/shoot.max;
        const gd=ctx.createLinearGradient(shoot.x,shoot.y,shoot.x-shoot.vx*7,shoot.y-shoot.vy*7);
        gd.addColorStop(0,"rgba(245,243,234,"+(0.85*fade)+")"); gd.addColorStop(1,"rgba(245,243,234,0)");
        ctx.strokeStyle=gd; ctx.lineWidth=1.6; ctx.lineCap="round";
        ctx.beginPath(); ctx.moveTo(shoot.x,shoot.y); ctx.lineTo(shoot.x-shoot.vx*7,shoot.y-shoot.vy*7); ctx.stroke();
        if(shoot.life>shoot.max||shoot.x>V.w) shoot=null; }
      if(!reduce) requestAnimationFrame(frame);
    }
    addEventListener("resize", resize, { passive:true }); resize();
    if(reduce) frame(performance.now()); else requestAnimationFrame(frame);
  })();
})();
